// Caveat footer rendered below every dimension chart in the expanded card.
//
// Reads the caveat copy from the shared per-dimension config in
// dimensions.ts and appends a link to the public disclaimer page (#255).
// Stable hook for tests: data-testid="chart-caveat".

import type { Dimension } from "../lib/dimensions";

interface Props {
  dimension: Dimension;
}

const DISCLAIMER_URL = "https://beamm.brussels/disclaimer/";

export function ChartCaveat({ dimension }: Props): JSX.Element {
  return (
    <p
      className="beamm-dimension-card-caveat"
      data-testid="chart-caveat"
    >
      {dimension.caveat} See{" "}
      <a
        href={DISCLAIMER_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="caveat-disclaimer-link"
      >
        disclaimer
      </a>
      .
    </p>
  );
}
